module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "newIntent",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "column": "",
      "primary-title": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Issuer",
      "hint": "pulled from your profile",
      "disabled": true,
      "required": true,
      "value": _vm.intent.Issuer
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "code",
    attrs: {
      "label": "Code will be generated...",
      "hint": "Code will be generated...",
      "disabled": true,
      "required": true,
      "value": _vm.intent.Code
    },
    on: {
      "input": _vm.updateCode
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    ref: "shortDescription",
    attrs: {
      "label": "Short description",
      "hint": "What will the data be used for?",
      "value": _vm.intent.ShortDescription
    },
    on: {
      "input": _vm.updateShortDescription
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "description",
    attrs: {
      "multi-line": "",
      "label": "Description",
      "hint": "What will the data be used for?",
      "value": _vm.intent.Description
    },
    on: {
      "input": _vm.updateDescription
    }
  }), _vm._v(" "), _c('v-select', {
    ref: "scopes",
    attrs: {
      "label": "Scopes",
      "hint": "What data will be retrieved?",
      "multiple": "",
      "chips": "",
      "autocomplete": "",
      "cache-items": "",
      "async-loading": _vm.loadingScopes,
      "value": _vm.intent.Scopes,
      "items": _vm.loadedScopes,
      "search-input": _vm.searchScopes
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchScopes = $event
      },
      "input": _vm.updateScopes
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('v-btn', {
    class: {
      disabled: !_vm.valid
    },
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add intent")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28b29c07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/IntentsNew.vue
// module id = 390
// module chunks = 0